import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import { NewIcon } from '../../../../components/newIcon/icon';
import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { FEATURES_CONFIG } from '../../businessFeatures.config';
import { FeaturesNavigationContainer, FeaturesNavigationItemContainer } from './featuresNavigation.styled';

const FeaturesNavigationTitle = () => {
  return (
    <TextWithHighlight>
      <h2 style={{ textAlign: 'center' }}>Discover all Pata's features</h2>
    </TextWithHighlight>
  );
};

export function FeaturesNavigation() {
  const handleNavigateToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);

    if (element) {
      const scrollOffset = -70;

      const scrollToY = element.getBoundingClientRect().top + window.pageYOffset + scrollOffset;

      window.scrollTo({ top: scrollToY, behavior: 'smooth' });
    }
  };

  const navigationConfig = FEATURES_CONFIG.map((item) => ({
    icon: item.icon,
    title: item.title,
    onClick: () => handleNavigateToSection(item.id),
    id: item.id,
  }));
  return (
    <WidthContainer noBackground>
      <SectionContainer title={FeaturesNavigationTitle}>
        <FeaturesNavigationContainer>
          {navigationConfig.map((item) => (
            <FeaturesNavigationItemContainer onClick={() => handleNavigateToSection(item.id)}>
              <NewIcon size="24px" type={item.icon} />

              <span>{item.title}</span>
            </FeaturesNavigationItemContainer>
          ))}
        </FeaturesNavigationContainer>
      </SectionContainer>
    </WidthContainer>
  );
}
